import React from "react"

// import Swiper core and required modules
import { Navigation, Pagination, Autoplay, Lazy } from "swiper"

import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"

// Import extra styling for arrows
import "./Slider.css"
import { GatsbyImage } from "gatsby-plugin-image"
import { RenderRichContent } from "../RenderRichContent/RenderRichContent"

const Slider = ({ data, headerOnTop }) => {
  //     let borderTop
  //   let borderBottom

  //   data.border[0] === "Border" ? (borderTop = styles.dashed) : (borderTop = "")
  //   data.borderBottom[0] === "Border"
  //     ? (borderBottom = styles.dashed)
  //     : (borderBottom = "")

  return (
    <>
      <div className="dashed mt-10"></div>
      <div className={"max-w-[1200px] mx-auto p-2"}>
        {headerOnTop && (
          <div className="text-center text-base block font-semibold">
            <RenderRichContent content={data.sliderIntro} />
          </div>
        )}
        <Swiper
          // install Swiper modules
          modules={[Navigation, Pagination, Autoplay, Lazy]}
          speed={600}
          navigation={false}
          // pagination={{
          //   enabled: true,
          //   clickable: true,
          //   dynamicBullets: true,
          //   dynamicMainBullets: 8,
          // }}
          pagination={false}
          lazy={{
            enabled: true,
            checkInView: true,
          }}
          onSwiper={swiper => ""}
          onSlideChange={() => ""}
          autoplay={
            (true,
            {
              delay: 4000,
            })
          }
          breakpoints={{
            // when window width is >= 325px
            325: {
              slidesPerView: 1,
              spaceBetween: 20,
              slidesPerGroup: 1,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 1,
              spaceBetween: 20,
              slidesPerGroup: 1,
            },
            // when window width is >= 768px
            769: {
              slidesPerView: 3,
              spaceBetween: 20,
              slidesPerGroup: 3,
            },
            1100: {
              slidesPerView: 4,
              spaceBetween: 20,
              slidesPerGroup: 4,
            },
          }}
        >
          {data?.sliderItems?.map((sliderItem, index) => {
            return (
              <SwiperSlide key={index}>
                <div
                  className={
                    "flex justify-between w-48 h-20 items-center mx-auto"
                  }
                >
                  <GatsbyImage
                    className={"w-48 max-h-20 my-auto"}
                    image={sliderItem.image.gatsbyImageData}
                    loading="eager"
                    alt={sliderItem.image.description || "slider-image"}
                  />
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
      <div className="dashed mb-10"></div>
    </>
  )
}

export default Slider
